import React from "react";
import { Sparkles, ShieldCheck } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Sidebar action banners — RFQ, ProPay One-Time Purchase, and Tax Exemption
 * Certificates. Extracted from InfoShopPage.jsx (v3.8.5) without changing
 * any visual or data-testid contract.
 */
export default function SidebarBanners({ t, onOpenRfq, onOpenOtp, onOpenExemptions }) {
  return (
    <>
      {/* RFQ banner */}
      <button
        onClick={onOpenRfq}
        data-testid="rfq-banner"
        className="w-full text-left rounded-xl bg-amber-50 border border-amber-200 p-4 hover:border-amber-400 transition-colors"
      >
        <div className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-amber-800 font-bold">
          <Sparkles size={12} /> {t("catalog.rfq_banner_eyebrow")}
        </div>
        <div className="font-display font-semibold text-slate-900 mt-1">{t("catalog.rfq_banner_title")}</div>
        <div className="text-xs text-slate-600 mt-1">{t("catalog.rfq_banner_help")}</div>
      </button>

      {/* Tail of the Tail · ProPay One-Time Purchase banner */}
      <button
        onClick={onOpenOtp}
        data-testid="otp-banner"
        className="w-full text-left rounded-xl p-4 transition-all hover:shadow-md hover:-translate-y-0.5 group"
        style={{
          background: "linear-gradient(135deg, #0B2A4A 0%, #0B2A4A 60%, #103A66 100%)",
          border: "1px solid rgba(0, 180, 216, 0.25)",
        }}
      >
        <div className="flex items-center justify-between gap-2">
          <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] font-bold text-[#7DD3FC]">
            <Sparkles size={12} /> {t("otp.entry.eyebrow")}
          </div>
          <div className="inline-flex items-center rounded-md bg-white px-2 py-1 shadow-sm shrink-0">
            <img
              src={`${BACKEND_URL}/api/static/site/propay-logo.png`}
              alt="ProPay Worldwide Inc."
              style={{ height: 16, width: "auto" }}
              className="object-contain"
            />
          </div>
        </div>
        <div className="font-display font-semibold text-white mt-2 leading-snug">
          {t("otp.entry.title")}
        </div>
        <div className="text-xs text-slate-300/85 mt-1.5 leading-relaxed line-clamp-3">
          {t("otp.entry.help")}
        </div>
        <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-bold text-[#00B4D8] uppercase tracking-wider group-hover:gap-2 transition-all">
          {t("otp.entry.cta")} →
        </div>
      </button>

      {/* Tax Exemption Certificates · Infosys Tax × Customer Legal/Tax */}
      <button
        onClick={onOpenExemptions}
        data-testid="tax-exemptions-banner"
        className="w-full text-left rounded-xl p-4 transition-all hover:shadow-md hover:-translate-y-0.5 group"
        style={{
          background: "linear-gradient(135deg, #064E3B 0%, #065F46 60%, #047857 100%)",
          border: "1px solid rgba(16, 185, 129, 0.30)",
        }}
      >
        <div className="flex items-center justify-between gap-2">
          <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] font-bold text-emerald-200">
            <ShieldCheck size={12} /> {t("exempt.entry.eyebrow")}
          </div>
          <span className="text-[10px] uppercase tracking-wider font-bold text-emerald-100 bg-emerald-500/20 border border-emerald-300/30 rounded px-1.5 py-0.5 shrink-0">
            {t("exempt.entry.scope_badge")}
          </span>
        </div>
        <div className="font-display font-semibold text-white mt-2 leading-snug">
          {t("exempt.entry.title")}
        </div>
        <div className="text-xs text-emerald-50/85 mt-1.5 leading-relaxed">
          {t("exempt.entry.help")}
        </div>
        <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-bold text-emerald-200 uppercase tracking-wider group-hover:gap-2 transition-all">
          {t("exempt.entry.cta")} →
        </div>
      </button>
    </>
  );
}
